<template>
  <v-footer
    id="appFooter"
    :class="[classes]"
    :color="color"
    app
    fixed
  >
    <v-container
      class="py-0 px-1 align-center justify-center"
      fluid
    >
      <v-row dense>
        <v-col
          class="gfp-copyright text-center"
          cols="12"
        >
          © {{ new Date().getFullYear() }} <a
            class="gfp-footer"
            href="https://www.otodev.gr/"
            target="_blank"
          ><strong>OTO Dev</strong></a> - Powered By <a
            class="gfp-footer"
            href="https://getfoodpro.gr/"
            target="_blank"
          ><strong>GETFOOD Pro</strong></a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name : 'AppFooter',
  props: {
    color: {
      type   : String,
      default: 'secondary'
    },

    classes: {
      type   : String,
      default: 'white--text px-1'
    }
  }
}
</script>

<style scoped>
.gfp-copyright {
  font-size: 14px;
  color: #FFFFFF;
}

.gfp-copyright > a,
.gfp-copyright > a:link,
.gfp-copyright > a:visited,
.gfp-copyright > a:active {
  text-decoration: none !important;
  color: #FFFFFF !important;
}

.gfp-copyright > a:hover {
  text-decoration: underline !important;
  color: #FFFFFF !important;
}
</style>
